/* eslint-disable @typescript-eslint/no-unused-vars */
import i18nInst from 'src/i18n';
import {
  ActionData,
  ActionEnum,
  DlpPolicyItem,
  EnableDisableEnum,
  ExchangeOnlinePolicyItem,
} from 'src/pages/Policy/utils/types';

import { PolicyTypeEnum } from '@Policy/utils/constants';
import { PolicyStore } from '@Policy/store';

export const wtpApprovedSenderEmailEntriesSelector = (state: PolicyStore) => {
  const template = state.template as ExchangeOnlinePolicyItem;
  const wtpApprovedSenderEmailEntries =
    template.tmWebthreatprotections.wtpApprovedSenderEmailEntries;
  const separator = ';';
  if (wtpApprovedSenderEmailEntries === '') {
    return [];
  }
  const list = wtpApprovedSenderEmailEntries
    .split(separator)
    .filter((item) => item.length > 0)
    .map((item) => ({
      name: item,
      value: item,
    }));
  return list;
};
export const wtpApprovedUrlListEntriesSelector = (state: PolicyStore) => {
  const template = state.template as ExchangeOnlinePolicyItem;
  const wtpApprovedUrlListEntries =
    template.tmWebthreatprotections.wtpApprovedUrlListEntries;
  const separator = ';';
  if (wtpApprovedUrlListEntries === '') {
    return [];
  }
  const list = wtpApprovedUrlListEntries
    .split(separator)
    .filter((item) => item.length > 0)
    .map((item) => ({
      name: item,
      value: item,
    }));
  return list;
};
export const wtpBlockedUrlListEntriesSelector = (state: PolicyStore) => {
  const template = state.template as ExchangeOnlinePolicyItem;
  const wtpBlockedUrlListEntries =
    template.tmWebthreatprotections.wtpBlockedUrlListEntries;
  const separator = ';';
  if (wtpBlockedUrlListEntries === '') {
    return [];
  }
  const list = wtpBlockedUrlListEntries
    .split(separator)
    .filter((item) => item.length > 0)
    .map((item) => ({
      name: item,
      value: item,
    }));
  return list;
};
export const wtpApprovedHeaderListSelector = (state: PolicyStore) => {
  const template = state.template as ExchangeOnlinePolicyItem;
  const wtpApprovedHeaderList =
    template.tmWebthreatprotections.wtpApprovedHeaderList;
  const str = wtpApprovedHeaderList.trim();
  if (str === '') {
    return [];
  }
  const list = JSON.parse(str);
  return list;
};
export const wtpTocApprovedUrlListSelector = (state: PolicyStore) => {
  const template = state.template as ExchangeOnlinePolicyItem;
  const tocApprovedUrlListEntries =
    template.tmWebthreatprotections.wtpTocApprovedUrlListEntries;
  const separator = ';';
  if (tocApprovedUrlListEntries === '') {
    return [];
  }
  const list = tocApprovedUrlListEntries
    .split(separator)
    .filter((item) => item.length > 0)
    .map((item) => ({
      name: item,
      value: item,
    }));
  return list;
};
export const wtpActionDataSelector = (state: PolicyStore) => {
  const template = state.template as ExchangeOnlinePolicyItem;
  const {
    config: {
      featureShow: { urlSandboxFeatureShow, gmailQtSettingFeatureShow },
    },
    setWtpState,
  } = state;
  const {
    tmWebthreatprotections: {
      wtpActionType,
      wtpNotifyType,
      wtpUnratedAction,
      wtpSuspiciousTag,
      wtpActionBlockedUrl,
      wtpBlockedUrlNotifyType,
    },
    tmDdafilters: { ddaURLEnabled },
  } = template;
  const policyType = state.template.policyType;
  let actionOptions: ActionEnum[] = [];
  let actionOptionsBlockedUrlList: ActionEnum[] = [];
  // Exchange
  const acitonOptionsExchange = [
    ActionEnum.tagSubject,
    ActionEnum.pass,
    ActionEnum.delete,
    ActionEnum.quarantine,
  ];
  const actionOptionsBlockedUrlListExchange = [
    ActionEnum.delete,
    ActionEnum.quarantine,
  ];
  // Gmail
  const actionOptionsGmail = gmailQtSettingFeatureShow
    ? [
        ActionEnum.delete,
        ActionEnum.pass,
        ActionEnum.labelEmail,
        ActionEnum.quarantine,
      ]
    : [ActionEnum.delete, ActionEnum.pass, ActionEnum.labelEmail];
  const actionOptionsBlockUrlListGmail = gmailQtSettingFeatureShow
    ? [ActionEnum.delete, ActionEnum.quarantine, ActionEnum.labelEmail]
    : [ActionEnum.delete, ActionEnum.labelEmail];
  // Gmail inline
  const actionOptionsGmailInline = [
    ActionEnum.tagSubject,
    ActionEnum.delete,
    ActionEnum.quarantine,
    ActionEnum.pass,
  ];
  const actionOptionsBlockUrlListGmainInline = [
    ActionEnum.quarantine,
    ActionEnum.delete,
  ];
  // Teams, OneDrive, SharePoint, Box, GoogleDrive, Dropbox
  const actionOptionsTeams = [
    ActionEnum.delete,
    ActionEnum.quarantine,
    ActionEnum.pass,
  ];
  const actionOptionsBlockUrlListTeams = [
    ActionEnum.delete,
    ActionEnum.quarantine,
  ];
  // Teams chat
  const actionOptionsTeamsChat = [ActionEnum.block, ActionEnum.pass];
  const actionOptionsBlockUrlListTeamsChat = [
    ActionEnum.block,
    ActionEnum.pass,
  ];
  // Salesforce
  const actionOptionsSalesforce = [
    ActionEnum.delete,
    ActionEnum.quarantine,
    ActionEnum.pass,
  ];
  const actionOptionsBlockUrlListSalesforce = [
    ActionEnum.delete,
    ActionEnum.quarantine,
    ActionEnum.pass,
  ];
  switch (policyType) {
    case PolicyTypeEnum.Exchange:
    case PolicyTypeEnum.ExchangeInline:
      actionOptions = acitonOptionsExchange;
      actionOptionsBlockedUrlList = actionOptionsBlockedUrlListExchange;
      break;
    case PolicyTypeEnum.Gmail:
      actionOptions = actionOptionsGmail;
      actionOptionsBlockedUrlList = actionOptionsBlockUrlListGmail;
      break;
    case PolicyTypeEnum.GmailInline:
      actionOptions = actionOptionsGmailInline;
      actionOptionsBlockedUrlList = actionOptionsBlockUrlListGmainInline;
      break;
    case PolicyTypeEnum.Teams:
    case PolicyTypeEnum.OneDrive:
    case PolicyTypeEnum.SharePoint:
    case PolicyTypeEnum.Box:
    case PolicyTypeEnum.GoogleDrive:
    case PolicyTypeEnum.Dropbox:
      actionOptions = actionOptionsTeams;
      actionOptionsBlockedUrlList = actionOptionsBlockUrlListTeams;
      break;
    case PolicyTypeEnum.SalesforceSandbox:
    case PolicyTypeEnum.SalesforceProduction:
      actionOptions = actionOptionsSalesforce;
      actionOptionsBlockedUrlList = actionOptionsBlockUrlListSalesforce;
      break;
    case PolicyTypeEnum.TeamsChat:
      actionOptions = actionOptionsTeamsChat;
      actionOptionsBlockedUrlList = actionOptionsBlockUrlListTeamsChat;
      break;
    default:
      break;
  }
  const { t } = i18nInst;
  const actionData: ActionData[] = [
    {
      threatType: t('policy.threatType.rulesMatchedUrls'),
      handler: setWtpState,
      action: wtpActionType,
      actionKey: 'wtpActionType',
      notifyType: wtpNotifyType,
      notifyTypeKey: 'wtpNotifyType',
      actions: actionOptions,
      otherSettings: {
        value: wtpUnratedAction,
        title: urlSandboxFeatureShow
          ? `${t('policy.threatType.action.otherSettingsForWTP')} ${t(
              'policy.threatType.action.otherSettingsForWTP.forUrlSandBox'
            )}`
          : `${t('policy.threatType.action.otherSettingsForWTP')}`,
        otherSettingKey: 'wtpUnratedAction',
        disabled: ddaURLEnabled === EnableDisableEnum.enabled,
      },
      suspiciousTag: wtpSuspiciousTag,
      suspiciousTagKey: 'wtpSuspiciousTag',
    },
    {
      threatType: t('policy.threatType.blockedURLList'),
      handler: setWtpState,
      action: wtpActionBlockedUrl,
      actionKey: 'wtpActionBlockedUrl',
      notifyType: wtpBlockedUrlNotifyType,
      notifyTypeKey: 'wtpBlockedUrlNotifyType',
      actions: actionOptionsBlockedUrlList,
    },
  ];
  return actionData;
};

export const wtpAdvancedOptionConfigSelector = (s: PolicyStore) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const {
    config: {
      defaultValue: {
        tmWebthreatprotections: {
          wtpReplacementText: wtpReplacementTextDefault,
        },
      },
    },
  } = s;
  const {
    tmWebthreatprotections: { wtpReplacementText },
  } = template;
  const config = {
    replaceFileName: '',
    replaceText: wtpReplacementText,
    replaceTextDefault: wtpReplacementTextDefault,
  };
  return config;
};

export const wtpAdvancedSettingsSelector = (s: PolicyStore) => {
  const template = s.template as ExchangeOnlinePolicyItem;
  const {
    config: {
      defaultValue: {
        tmWebthreatprotections: {
          wtpReplacementText: wtpReplacementTextDefault,
        },
      },
    },
  } = s;
  const {
    tmWebthreatprotections: {
      wtpFileTagEnabled,
      wtpFileAction,
      wtpFileActionNotifyType,
      wtpSecondActionEnabled,
      wtpSecondActionType,
      wtpFileTagContent,
      wtpReplacementText,
    },
  } = template;
  const config = {
    firstActionEnabled: wtpFileTagEnabled,
    firstActionType: wtpFileAction,
    firstActionNotifyType: wtpFileActionNotifyType,
    secondActionEnabled: wtpSecondActionEnabled,
    secondActionType: wtpSecondActionType,
    replaceFileTagContent: wtpFileTagContent,
    replaceText: wtpReplacementText,
    replaceTextDefault: wtpReplacementTextDefault,
  };
  return config;
};

export const salesforceAdvancedSettingsSelector = (s: PolicyStore) => {
  const template = s.template as DlpPolicyItem;
  const {
    config: {
      defaultValue: {
        tmDpfilters: { dpReplacementText: replaceTextDefault },
      },
    },
  } = s;
  const {
    tmDpfilters: {
      dpFileTagEnabled: firstActionEnabled,
      dpFileAction: firstActionType,
      dpSecondActionEnabled: secondActionEnabled,
      dpSecondActionType: secondActionType,
      dpFileTagContent: replaceFileTagContent,
      dpReplacementText: replaceText,
    },
  } = template;
  const config = {
    firstActionEnabled,
    firstActionType,
    secondActionEnabled,
    secondActionType,
    replaceFileTagContent,
    replaceText,
    replaceTextDefault,
  };
  return config;
};
